import { render } from "./ContentCampaigns.vue?vue&type=template&id=65919abe&scoped=true"
import script from "./ContentCampaigns.vue?vue&type=script&lang=js"
export * from "./ContentCampaigns.vue?vue&type=script&lang=js"

import "./ContentCampaigns.vue?vue&type=style&index=0&id=65919abe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65919abe"]])

export default __exports__